export var eventManager = {
    list: new Map(),
    emitQueue: new Map(),
    on: function (event, callback) {
        this.list.has(event) || this.list.set(event, []);
        this.list.get(event).push(callback);
        return this;
    },
    off: function (event, callback) {
        if (callback) {
            var cb = this.list.get(event).filter(function (cb) { return cb !== callback; });
            this.list.set(event, cb);
            return this;
        }
        this.list.delete(event);
        return this;
    },
    cancelEmit: function (event) {
        var timers = this.emitQueue.get(event);
        if (timers) {
            timers.forEach(clearTimeout);
            this.emitQueue.delete(event);
        }
        return this;
    },
    /**
     * Enqueue the event at the end of the call stack
     * Doing so let the user call toast as follow:
     * toast('1')
     * toast('2')
     * toast('3')
     * Without setTimemout the code above will not work
     */
    emit: function (event) {
        var _this = this;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        this.list.has(event) &&
            this.list.get(event).forEach(function (callback) {
                var timer = setTimeout(function () {
                    // @ts-ignore
                    callback.apply(void 0, args);
                }, 0);
                _this.emitQueue.has(event) || _this.emitQueue.set(event, []);
                _this.emitQueue.get(event).push(timer);
            });
    },
};
